import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component

import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import { DynamicFormDefinition, User } from '../../../common';
import UserActionList from './cell-renderers/user-action-list';
import { UserListEvent } from './user-list-events';

const UserList = ({ users, clientId, callback }: {
  users: any,
  clientId: string | undefined,
  callback: (event: UserListEvent, user: User, clientId: string | undefined) => void
}) => {

  const gridRef = useRef<any>(); // Optional - for accessing Grid's API

  // Each Column Definition results in one Column.
  // const [columnDefs, setColumnDefs] = useState([
  //   { field: 'make', filter: true },
  //   { field: 'model', filter: true },
  //   { field: 'price' }
  // ]);
  const [columnDefs, setColumnDefs] = useState([
    { field: 'username', filter: true },
    { field: 'id' },
    { field: 'roles' },
    {
      field: 'actions', minWidth: 200, cellRenderer: UserActionList, cellRendererParams: {
        callback: (event: UserListEvent, user: User, clientId: string | undefined) => callback(event, user, clientId)
      },
    }
  ]);

//   const callback = (event: UserListEvent, user: User, clientId: string | undefined) => {
//     alert (event);
//   }

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true
  }), []);

  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event: unknown) => {
    console.log('cellClicked', event);
  }, []);

  const onGridSizeChanged = useCallback((params: unknown) => {
    gridRef.current.api.sizeColumnsToFit();
    const columns = gridRef.current.columnApi.getAllGridColumns();
    const lastColumn = columns[columns.length - 1];
    gridRef.current.columnApi.setColumnWidth(lastColumn.colId, lastColumn.actualWidth - 1);
  }, []);

  return (
    <div className="ag-theme-alpine" style={{ width: "100%", height: "100%", minHeight: "300px" }}>

      <AgGridReact
        ref={gridRef} // Ref for accessing Grid's API

        rowData={users} // Row Data for Rows

        columnDefs={columnDefs} // Column Defs for Columns
        defaultColDef={defaultColDef} // Default Column Properties

        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
        rowSelection='single' // Options - allows click selection of rows
        suppressRowClickSelection={true}

        onCellClicked={cellClickedListener} // Optional - registering for Grid Event
        onGridSizeChanged={onGridSizeChanged}
      />
    </div>
  );
};

export default UserList;
